import {ReactNode} from "react";
import {StyleSheet, View, ViewStyle} from "react-native";

type Props = {
    children: ReactNode,
    style?: ViewStyle,
    vertical?: boolean,
}

// Navigation buttons at the bottom of the screen.
// Always full-width on mobile devices, with a large gap between buttons.
// Maximum 400 pixels on web.
export default function Nav({children, style}: Props) {
    return (
        <View
            style={[
                styles.container,
                style
            ]}
        >
            {children}
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        paddingVertical: 16,
        gap: 24,
        maxWidth: 400,
        width: "100%",
        flexDirection: "column",
        marginHorizontal: "auto",
    },
});